import { Box } from '@vapor/material'
import { FC } from 'react'

/**
 * Layout delle pagine pubblice, fuori contesto di autenticazione
 */
export const PublicPageLayout: FC = (props) => {
  return (
    <Box sx={{ height: '100%' }}>{props.children}</Box>
  )
}
